/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_sex_female = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Female`)
};

const es_bmr_sex_female = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mujer`)
};

const de_bmr_sex_female = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiblich`)
};

const nl_bmr_sex_female = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vrouw`)
};

const fr_bmr_sex_female = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Femme`)
};

const it_bmr_sex_female = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Femmina`)
};

const pt_br2_bmr_sex_female = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feminino`)
};

const pt_bmr_sex_female = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feminino`)
};

const ja_bmr_sex_female = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`女性`)
};

const zh_bmr_sex_female = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`女性`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_sex_female = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_sex_female(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_sex_female", locale)
	if (locale === "en") return en_bmr_sex_female(inputs)
	if (locale === "es") return es_bmr_sex_female(inputs)
	if (locale === "de") return de_bmr_sex_female(inputs)
	if (locale === "nl") return nl_bmr_sex_female(inputs)
	if (locale === "fr") return fr_bmr_sex_female(inputs)
	if (locale === "it") return it_bmr_sex_female(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_sex_female(inputs)
	if (locale === "pt") return pt_bmr_sex_female(inputs)
	if (locale === "ja") return ja_bmr_sex_female(inputs)
	return zh_bmr_sex_female(inputs)
};